module.exports = __webpack_public_path__ + "img/ammiraglio 2.a457ccf8.jpeg";